<template>
  <button
    ref="refButtonAttendees"
    class="button-white button-big button-rounded"
    @click="onClickButtonAttendees"
    :class="{ active: isVisibleAttendees }"
  >
    <div class="icon-user-wrap">
      <IconUser class="icon-medium" />
      <p class="smaller accent status-dot">{{ messageStore.activeAttendees.length }}</p>
    </div>
  </button>

  <!-- 참석자리스트 -->
  <NavMenu
    v-if="isVisibleAttendees"
    :target-el="refButtonAttendees"
    :title="$t('participants')"
    @close="closeDropdownAttendees"
  >
    <DropdownAttendees
      :attendees="messageStore.activeAttendees"
      :partner-person="isPartnerPerson"
      @evict="alertConfirmEvictGuest"
      @close="closeDropdownAttendees"
    />
  </NavMenu>
</template>

<script setup lang="ts">
import { computed, ref, useTemplateRef } from 'vue';

import DropdownAttendees from '@/components/domains/chat/common/DropdownAttendees.vue';
import IconUser from '@/components/icons/IconUser.vue';
import NavMenu from '@/components/shared/composite/NavMenu.vue';
import { useNotification } from '@/composables/shared/useNotification';
import { useCallStore } from '@/stores/call';
import { QRCodeType } from '@/stores/chat';
import { useMessageStore } from '@/stores/message';

const callStore = useCallStore();

const messageStore = useMessageStore();
const { alertConfirmEvictGuest } = useNotification();

const refButtonAttendees = useTemplateRef('refButtonAttendees'); // 참석자 버튼
const isVisibleAttendees = ref(false); // 참석자 드롭다운이 보이는지 여부

// 파트너 여부 반환
const isPartnerPerson = computed<boolean>(() => {
  return QRCodeType.isEmployee(callStore.qrCodeInfo.qrCodeType);
});

// 참석자 드롭다운 열기
const openDropdownAttendees = () => {
  isVisibleAttendees.value = true;
};

// 참석자 드롭다운 닫기
const closeDropdownAttendees = () => {
  isVisibleAttendees.value = false;
};

// 참석자 버튼 클릭 시
const onClickButtonAttendees = () => {
  if (isVisibleAttendees.value) {
    closeDropdownAttendees();
  } else {
    openDropdownAttendees();
  }
};
</script>

<style scoped lang="scss">
.icon-user-wrap {
  position: relative;
  display: flex;
  height: 1.5rem;
  min-width: 1.5rem;
  align-items: center;
}

.status-dot {
  position: relative;
  padding: 0.125rem 0.5rem;
  min-width: 0.25rem;
  border-radius: 30px;
  right: 0;
  color: var(--primary);
  background-color: var(--surface-primary-dimmer);
}

.button-big {
  padding-right: 0.5rem !important;
}
</style>
